import React from 'react';

import { CNAME_SPACER } from '../CONSTANTS';

export const Spacer = () => <span className={CNAME_SPACER} role="none" />;

export default Spacer;
